// CardPainterHost/CardPainterHost.jsx
// Generic shell. Knows only PainterRegistry + the Painter contract.
// Never imports or references concrete widgets (CryptoPriceWidget, etc) directly —
// that would leak domain knowledge into the shell and break the domain-agnostic design.
import React from 'react';
import CoreComponent from '../../../services/engines/CoreComponent';
import painterRegistry from '../Core/PainterRegistry';

class CardPainterHost extends CoreComponent {
    render() {
        const { registryKey, ...rest } = this.props;
        const PainterComponent = painterRegistry.resolve(registryKey);

        if (!PainterComponent) {
            // Graceful skip — no painter registered for this key, no crash.
            this.logDebug('CardPainterHost', 'Graceful skip — no painter registered for this key, no crash');
            return null;
        }

        return <PainterComponent {...rest} />;
    }
}

export default CardPainterHost;
